import { useCallback, useMemo } from 'react';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

/**
 * Typesense docs store photo paths relative to the assets host (e.g. "photos/4/bm/bu/abc-fullsize.jpg")
 */
export function useSearchAssetUrl(): (path: string | undefined) => string | undefined {
	const { environment } = useUtilityContext();

	const assetsHost = useMemo(
		() =>
			environment.getEnvironment() === 'production'
				? 'https://assets.change.org/'
				: 'https://assets.staging-change.org/',
		[environment],
	);

	return useCallback((path: string | undefined) => (path ? `${assetsHost}${path}` : undefined), [assetsHost]);
}
